import * as React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import {Copy} from '../../system/buttons';
import moment from 'moment';

export const Coupon = ({coupons, premium}) => {
  if (coupons && coupons.length >= 1 && premium) {
    const {shareable} = coupons[0];
    const {isPremium, isLifetime} = premium;
    return (
      <Col id={'coupons'} className={'pt-3'}>
        <h5>Available coupons</h5>
        {!(isPremium && isLifetime) && (
          <div>
            Redeem your coupon above{' '}
            {shareable ? 'or share it with your friends' : ''}
          </div>
        )}
        {isPremium && isLifetime && (
          <div>
            Wow, looks like you have a lifetime of the BRO plan already. Thank
            you for your support! Share your coupon with your friend!
          </div>
        )}
        {coupons.map(({coupon, endedAt, duration}) => {
          return (
            <React.Fragment key={coupon}>
              <Row>
                <Col>
                  <Form.Control value={coupon} readOnly />
                </Col>
                <Col>
                  <Copy title={'Copy!'} text={coupon} />
                </Col>
              </Row>
              <div>
                expires on {moment(new Date(Date.parse(endedAt))).format('LL')}
                {', '}
                gives {moment.duration(duration).asDays()} days
              </div>
            </React.Fragment>
          );
        })}
      </Col>
    );
  } else {
    return <></>;
  }
};
